import { Component, inject, Input, OnInit } from '@angular/core';
import {
  LargedTuileComponent,
  TuileButtonProps,
} from '../../../../../../../../components/ecosystems/larged-tuile/larged-tuile.component';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import {
  DeviceActionStackService,
  EdroNetworkManager,
  FunctionOnglet,
} from '../../../../../../manager/edro-network-manager';
import { IProduct, IProductFunctionnality } from '../../../../../IProduct';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00031 } from '../../../../P00031';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';

@Component({
  selector: 'app-p00039-card-couverture-controle',
  templateUrl: './p00039-card-couverture-controle.component.html',
  styleUrls: ['./p00039-card-couverture-controle.component.scss'],
  imports: [LargedTuileComponent, TranslatePipe],
})
export class P00039CardCouvertureControleComponent implements OnInit {
  private edroNetworkManager = inject(EdroNetworkManager);
  private translateService = inject(TranslateService);
  @Input() productClass: IProduct | null = null;
  public actionStack: DeviceActionStackService | null = null;

  public buttons: TuileButtonProps[] = [];

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );

    this.buttons = [
      {
        title: 'P00039.card.state.cover.title.open',
        icon: 'fa-kit fa-picto-couvfermeedeux',
        color: 'color-green',
        status: 'active',
      },
      {
        title: 'P00039.card.state.cover.title.close',
        icon: 'fa-kit fa-picto-couvouvertedeux',
        color: 'color-red',
        status: 'inactive',
      },
    ];
  }

  async openProductModal() {
    await this.edroNetworkManager.openProductModal(
      this.productClass!,
      IProductFunctionnality.COUVERTURE,
      FunctionOnglet.CONTROL,
      this.translateService.instant('dashboard.cover'),
    );
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
}
